exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".page-headline__title[data-v-cdfeea90] {\n  font-weight: bold;\n  font-size: 1.8rem;\n  line-height: 1.6;\n}\n", ""]);
